import React from 'react'
import { sanitizeUrl } from '@ampcore/string-format'
import xss from 'xss'

export interface VideoPosterProps {
  posterUrl: string
  isLoading: boolean
  isVisible: boolean
  onActivate: () => void
  instanceLabel: string
  errorMessage?: string
  /** Renders a non-interactive preview: muted play button, disabled cursor. */
  previewOnly?: boolean
}

export const VideoPoster: React.FC<VideoPosterProps> = ({
  posterUrl,
  isLoading,
  isVisible,
  onActivate,
  instanceLabel,
  errorMessage,
  previewOnly = false
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (previewOnly) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onActivate()
    }
  }

  return (
    <button
      type="button"
      className={`video-poster ${isVisible ? '' : 'is-hidden'} ${
        isLoading ? 'is-loading' : ''
      } ${previewOnly ? 'video-poster--preview' : ''}`}
      onClick={previewOnly ? undefined : onActivate}
      onKeyDown={handleKeyDown}
      aria-label={previewOnly ? 'Preview only' : `Play video: ${instanceLabel}`}
      title={previewOnly ? 'Preview Only' : undefined}
      disabled={isLoading || previewOnly}
    >
      <img src={sanitizeUrl(xss(posterUrl))} alt="Video poster" />
      {isVisible &&
        (isLoading ? (
          <div className="play-loader" />
        ) : (
          <div className="play-icon u-flex u-flexAlignItemsCenter u-flexJustifyCenter" />
        ))}
      {errorMessage && (
        <div className="video-error-message">{errorMessage}</div>
      )}
    </button>
  )
}
